import React, { useRef, useState } from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import { Form, Page } from 'src/@vymo/ui/molecules';
import {
  FormFieldState,
  FormVersion,
  InputFieldConfig,
} from 'src/@vymo/ui/molecules/form/types';
import { Keys, locale } from 'src/i18n';
import { UPLOAD_FORM } from 'src/modules/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { removeDialog } from 'src/workspace/slice';
import { getAllocationTypes } from '../selectors';
import { BASE_URL } from '../thunk';
import { getInputsConfig } from './queries';
import { uploadFormSubmit } from './thunk';
import { UploadFormProps } from './types';
import styles from './index.module.scss';

function UploadForm({
  inputsConfig,
  title,
  actionType,
  additionalData = {},
}: UploadFormProps) {
  const formRef = useRef(null);
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState<Record<string, FormFieldState>>({});

  const onFormChange = (formFields: Record<string, FormFieldState>) => {
    setFormData(formFields);
  };

  const allocationTypes = useAppSelector((state) =>
    getAllocationTypes(state, actionType),
  );

  const onFormSubmit = async () => {
    // @ts-ignore
    const result = await formRef.current?.getFieldsForSubmission?.();
    if (result?.valid === 'valid') {
      dispatch(
        uploadFormSubmit({
          inputFields: result.data,
          actionType,
          additionalData,
        }),
      );
    }
  };

  const resolvedInputsConfig = getInputsConfig(
    inputsConfig,
    actionType,
    formData,
    allocationTypes,
  ) as InputFieldConfig[];

  return (
    <Page className={styles.formPage}>
      <Page.Header className={styles.formPage__header}>
        <Text bold type="h5" data-test-id={`${title}-upload-form`}>
          {title}
        </Text>
      </Page.Header>

      <Page.Body>
        <Form
          key={title}
          ref={formRef}
          id="uploadForm"
          name="uploadForm"
          span="1fr"
          className={styles.actionForm__form}
          config={{
            version: FormVersion.webRevyre,
            data: resolvedInputsConfig,
            grouping: [],
            fieldItemConfig: {
              showDisabledIcon: true,
            },
            metaData: {
              revyre: true,
            },
            beforeSaveHookConfig: {
              multimedia: {
                isMultimediaBeforeSaveHookDisabled: false,
                uploadUrl: `${BASE_URL}/dms`,
                valueFormat: 'jsonString',
              },
            },
            viewMode: false,
          }}
          onChange={onFormChange}
          value={formData}
        />
      </Page.Body>
      <Page.Footer className={styles.formPage__footer}>
        <Button
          data-test-id="upload-form-cancel"
          type="text"
          onClick={() => {
            dispatch(removeDialog({ id: UPLOAD_FORM }));
          }}
        >
          {locale(Keys.CANCEL)}
        </Button>

        <Button onClick={onFormSubmit} data-test-id="upload-form-submit">
          {locale(Keys.SUBMIT)}
        </Button>
      </Page.Footer>
    </Page>
  );
}

export default UploadForm;
